import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
            aria-label="桃花视频首页"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-xl text-white"></i>
            </div>
            <span className="text-xl font-bold font-heading text-foreground-900 whitespace-nowrap">
              桃花视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索视频..."
                className="w-48 pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <button className="px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              登录 / 注册
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-4">
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="搜索视频..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <div className="grid grid-cols-3 gap-2 mb-4">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                  className={`text-center py-2 text-sm rounded-lg transition-colors duration-200 cursor-pointer ${
                    (cat.slug === 'all' && location.pathname === '/') ||
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-100 text-primary-600 font-medium'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <div className="flex items-center gap-3">
              <Link
                to="/about"
                className="flex-1 text-center py-2.5 text-sm rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
              >
                关于我们
              </Link>
              <button className="flex-1 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                登录 / 注册
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}